import { PropsWithChildren } from "react";

import { TableColumnSettingsContext } from "./TableColumnSettingsContext";
import { useTableColumnSettings } from "./useTableColumnSettings";

type Props<T extends string> = PropsWithChildren<{
  tableId: Parameters<typeof useTableColumnSettings<T>>[0]["tableId"];
  defaultColumnSettings: Parameters<
    typeof useTableColumnSettings<T>
  >[0]["defaultColumnSettings"];
  defaultColumnOrder?: Parameters<
    typeof useTableColumnSettings<T>
  >[0]["defaultColumnOrder"];
}>;

export const TableColumnSettingsProvider = <T extends string>({
  children,
  tableId,
  defaultColumnSettings,
  defaultColumnOrder,
}: Props<T>) => {
  const tableColumnSettings = useTableColumnSettings<T>({
    tableId,
    defaultColumnSettings,
    defaultColumnOrder,
  });

  return (
    <TableColumnSettingsContext.Provider value={{
      ...tableColumnSettings,
      columnOrder: tableColumnSettings.columnOrder as string[],
      updateColumnOrder: tableColumnSettings.updateColumnOrder as (columnOrder: string[]) => void,
    }}>
      {children}
    </TableColumnSettingsContext.Provider>
  );
};
